export default Object.freeze({
  // GRID_LAYER_
  TITLE: '그리드 컬럼 개인설정',
  CHECK_EXPOSURE: '체크컬럼 노출',
  CHECK_UNEXPOSED: '체크컬럼 미노출',
  ALL_EXPOSURE: '전체 노출',
  ALL_UNEXPOSED: '전체 미노출',
  ORDER: '순서',
  COLUMN_NAME: '컬럼명',
  EXPOSURE_TYPE: '노출여부',
  EXPOSURE: '노출',
  UNEXPOSED: '미노출',

  ALL_UNEXPOSED_MSG: '그리드 컬럼은 최소 1개이상 노출되어야합니다',
  NOT_SELECTED_MSG: '컬럼을 선택해주세요.',
  SAVE_MSG: '컬럼 개인설정이 저장되었습니다.'
});
